export enum SplitTreatmentName {
  // Read gate for migrated (legacy-Firestore) design projects, EN-5987. Creating
  // a design_project row IS the routing cutover, so every consumer filters
  // migrated rows out until this is "on" for that account. Keep the value in
  // sync with MIGRATED_DESIGN_PROJECT_ROUTING_FLAG in @yardzen/design-project-gate
  // — apps/api reads the same flag through its own Split wrapper, and a mismatch
  // would gate the two halves of a client's routing differently.
  LEGACY_ONBOARDING_MIGRATED_ROUTING = "LEGACY_ONBOARDING_MIGRATED_ROUTING",
  BUILD_STUDIO_EXP = "BUILD_STUDIO_EXP",
  CONTRACTOR_IN_APP_FORM_UPDATES = "CONTRACTOR_IN_APP_FORM_UPDATES",
  // Launch kill-switch for the Toll Brothers co-branded onboarding (EN-5599).
  // Routing INTO the (toll) flow is driven by the Toll promo code; this flag
  // only exists so the co-branded experience can be disabled instantly at
  // launch (treatment "off" => Toll buyers fall back to standard onboarding).
  TOLL_ONBOARDING = "TOLL_ONBOARDING",
  // Kill-switch for the shared builder-partner promo code's email-match check
  // at checkout. The check runs ONLY when the treatment is "on" — anything
  // else (off, control from a Split outage) fails open to
  // product-restriction-only, so flag infra can never block real buyers.
  BUILDER_PARTNER_PROMO_EMAIL_MATCH = "BUILDER_PARTNER_PROMO_EMAIL_MATCH",
  // Cutover for builder-partner identification: "on" derives the
  // partner decisions (webhook attach, onboarding-step partition, post-payment
  // redirect) from promo metadata + the buyer email match instead of the
  // TOLL_PROMO_CODE env compare. Anything else (off, control) keeps the legacy
  // env-var gate byte-for-byte, so the flag is a full rollback switch.
  BUILDER_PARTNER_IDENTIFICATION_CUTOVER = "BUILDER_PARTNER_IDENTIFICATION_CUTOVER",
  // EN-5920. Routes the invoice payment page through server-side finalization
  // (ConfirmationToken) instead of client-side stripe.confirmPayment. Treatment
  // "on" enables it; anything else (off, control from a Split outage) keeps the
  // legacy confirm path byte-for-byte, so this is a full rollback switch.
  INVOICE_SERVER_FINALIZE = "INVOICE_SERVER_FINALIZE",
  // EN-5920. The US-only card policy for invoice payments. ONLY the exact
  // treatment "enforce" blocks a non-US card; "observe" evaluates and logs but
  // still takes the payment, which is also what off/control do. Blast radius is
  // sized from the observe logs before enforcing.
  INVOICE_FOREIGN_CARD_POLICY = "INVOICE_FOREIGN_CARD_POLICY",
  // The credit-only card policy for invoice payments. ONLY the exact treatment
  // "enforce" blocks; "observe" evaluates and logs but still takes the payment,
  // as do off/control. Ramps independently of INVOICE_FOREIGN_CARD_POLICY, so a
  // card can be refused by either, both, or neither. Debit, prepaid, and cards
  // whose funding Stripe does not report are all refused when enforcing.
  INVOICE_DEBIT_CARD_POLICY = "INVOICE_DEBIT_CARD_POLICY",
}
